module.exports = __webpack_public_path__ + "static/fonts/iconfont.edb14529.ttf";